import React from 'react';
import { useTranslation } from 'react-i18next';

// Playouts wording depends on the campaign mode: PMP estimates them, PG projects
// them, traditional buys a minimum. The shapes live in the dictionary so each
// language keeps its own word order.
const QUALIFIER_KEYS = {
  traditional: 'minimum playouts qualifier',
  pmp: 'estimated playouts qualifier',
  pg: 'projected playouts qualifier'
};

const SHAPE_KEYS = {
  base: 'playouts label',
  subsidized: 'subsidized playouts label',
  perDay: 'playouts per day label'
};

// Approved campaigns show what is left to deliver, not the whole purchase.
const REMAINING_SHAPE_KEYS = {
  base: 'playouts remaining label'
};

/**
 * Resolves the playouts label as a plain string, for call sites that need one
 * (placeholder, message, string prop) instead of the component.
 */
const resolveMode = ({ programmatic, isGuaranteed }) =>
  programmatic !== 'programmatic' ? 'traditional' : isGuaranteed ? 'pg' : 'pmp';

/**
 * The qualifier on its own (estimados / proyectados / minimos), for sentences
 * that say "playouts <qualifier>" outside the label shapes.
 */
export const getPlayoutsQualifier = (campaign, t) => t(QUALIFIER_KEYS[resolveMode(campaign)]);

export const getPlayoutsLabel = (
  { programmatic, isGuaranteed, variant = 'base', remaining },
  t
) => {
  const shape =
    (remaining && REMAINING_SHAPE_KEYS[variant]) || SHAPE_KEYS[variant] || SHAPE_KEYS.base;
  return t(shape, { qualifier: getPlayoutsQualifier({ programmatic, isGuaranteed }, t) });
};

/**
 * @param {'base'|'subsidized'|'perDay'} variant
 * @param {boolean} remaining - label the pending part instead of the total
 * Campaign mode comes from redux through PlayoutsLabelContainer.
 */
const PlayoutsLabel = ({ variant, remaining, programmatic, isGuaranteed }) => {
  const { t } = useTranslation();
  return <>{getPlayoutsLabel({ programmatic, isGuaranteed, variant, remaining }, t)}</>;
};

export default PlayoutsLabel;
